const start = require('@ikegps/client-ui').default;

start();
